import { RouteLocationNormalizedLoaded } from 'vue-router'

/**
 * Route関連の関数を返す
 * @param route route
 * @returns Route関連の関数
 */
const useRouteUtil = (route: RouteLocationNormalizedLoaded) => {
  /**
   * クエリデータを取得する
   * @param key クエリキー
   * @param defaultValue デフォルト値
   * @returns 指定したキーのクエリ値
   */
  const getQueryData = (key: string, defaultValue: string): string => {
    const data = route.query[key]
    // 定義取得できない場合はデフォルト値またはundefinedを返す
    if (!data) {
      return defaultValue
    }
    // この関数は同じ名前のクエリが1つである前提とする
    return data as string
  }
  return {
    getQueryData,
  }
}

export { useRouteUtil }
